module.exports = __webpack_public_path__ + "static/media/indian.638ca5e2.jpg";